import { TransactionStatus } from '@core/models/transaction';

export interface TransactionListParams {
  page: number;
  limit: number;
  status?: TransactionStatus;
  sender?: string;
  receiver?: string;
  type?: string;
  dateRange?: string;
  term?: string;
  sort?: string;
  direction?: 'ASC' | 'DESC';
}
